import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import CMS from "@/utils/cms.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import ClickableBgOverlay from "@/ui/ClickableBgOverlay.tsx";
import clsx from "clsx";
import st from "@/styles/VerifyAccount.module.scss";
import {isMobile} from "react-device-detect";
import ChevroneIcon from "@/svg/ChevronIocn.tsx";
import LazyImage from "@/ui/LazyImage.tsx";



const local_events = {
    set_show_instr:"set_show_instr"
}


const KYCInstructions = () => {
    const [show_instr, set_show_instr] = useState<boolean>(true)
    const {t, i18n} = useTranslation()
    const raw_data = CMS["confirm-identity"]
    
    const data = CMS.langAwareFilter(raw_data, (i18n.language as LocalLanguage))
    
    const show_instr_handler = (x:boolean) => {
        set_show_instr(x)
    }
    
    useEffect(() => {
        
        eventEmitter.on(local_events.set_show_instr, show_instr_handler)
        
        return () => {
            eventEmitter.off(local_events.set_show_instr, show_instr_handler)
        }
    }, []);
    
    return (
        <>
            
            <ClickableBgOverlay
                className={clsx(st.instr_overlay, show_instr && st.overlay_active, /*isMobile && st.overlay_mobile*/)}
                onClick={() => {
                    set_show_instr(false)
                }}
            />
            
            <div className={clsx(st.instructions, show_instr && st.active, isMobile && st.mobile)}>
                <div
                    onClick={() => {
                        if(!isMobile) {
                            set_show_instr((x) => !x)
                        }
                    }}
                    className={st.head}
                >
                    {/*{isMobile ? (*/}
                    {/*    <span className={st.popup_header}>*/}
                    {/*        {t("doc_scan")}*/}
                    {/*    </span>*/}
                    {/*) : (*/}
                    <span className={st.popup_header}>
                            {t("doc_img_quality")}
                        </span>
                    {/*)}*/}
                    
                    {isMobile ? (
                        // <CloseBtn
                        //     onClick={() => {
                        //         set_show_instr(false)
                        //     }}
                        // />
                        
                        // <button
                        //     onClick={() => {
                        //         set_show_instr(false)
                        //     }}
                        //     className={st.show_instr}
                        // >
                        //     {t("got_it")}
                        // </button>
                        <></>
                    
                    ) : (
                        <ChevroneIcon/>
                    )}
                
                </div>
                
                {isMobile && (
                    <span className={st.inf}>
                        {t("kyc1_inf") + " "} {isMobile && t("show_document") + ":"}
                    </span>
                )}
                
                {show_instr && (
                    <div className={st.rules}>
                        <div className={st.container}>
                            
                            {(Array.isArray(data.rules) && data.rules.length) ? data.rules.map((x:any, i:number) => {
                                
                                const obj = CMS.langAwareFilter(x, (i18n.language as LocalLanguage))
                                
                                const {images, description, label } = obj
                                
                                return (
                                    <div key={`doc_rule_${i}`} className={st.rule_item}>
                                        
                                        <strong>
                                            {label && label}
                                        </strong>
                                        
                                        <p>
                                            {description && description}
                                        </p>
                                        
                                        {(Array.isArray(images) && images.length) ? (
                                            
                                            <div className={st.images}>
                                                {images.map((img, j) => {
                                                    return (
                                                        <LazyImage className={st.img_item} key={`doc_img_${j}_${i}`} src={CMS.getFilePath(img.path)} alt="doc_img" />
                                                    )
                                                })}
                                            </div>
                                        
                                        ) : null}
                                    
                                    </div>
                                )
                            }) : null}
                        
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default KYCInstructions